module.exports = __webpack_public_path__ + "media/images/opt_in_background-9b92a27a.png";